import React, { useEffect, useState } from "react";
import Layout from "../components/Layout";
import api from "../services/api";
import { useNavigate } from "react-router-dom";

export default function CreateRequest() {

  const navigate = useNavigate();

  const [technicians, setTechnicians] = useState([]);

  const [form, setForm] = useState({
    customer_name: "",
    phone: "",
    email: "",
    address: "",
    service_type: "HOME_SERVICE",
    technician_id: "",
  });

  useEffect(() => {

    api.get("/users?role=Technician")
      .then(res => {

        setTechnicians(
          Array.isArray(res.data)
            ? res.data
            : []
        );

      })
      .catch(err => {

        console.error("Users fetch failed:", err);
        setTechnicians([]);

      });

  }, []);

  const submit = async (e) => {

    e.preventDefault();

    try {

      await api.post("/requests/admin", form);

      alert("Repair request created");

      navigate("/dashboard");

    } catch (err) {

      console.error(err);

      alert("Could not create request");

    }
  };

  return (
    <Layout>

      <div className="max-w-xl mx-auto">

        <h1 className="text-2xl font-bold mb-6 text-indigo-600">
          Create Repair Request
        </h1>

        <form
          onSubmit={submit}
          className="space-y-4 bg-white p-6 rounded shadow"
        >

          <input
            placeholder="Customer Name"
            className="w-full p-2 border rounded"
            value={form.customer_name}
            onChange={(e) =>
              setForm({
                ...form,
                customer_name: e.target.value
              })
            }
            required
          />

          <input
            placeholder="Phone Number"
            className="w-full p-2 border rounded"
            value={form.phone}
            onChange={(e) =>
              setForm({
                ...form,
                phone: e.target.value
              })
            }
            required
          />

          <input
            placeholder="Email"
            className="w-full p-2 border rounded"
            value={form.email}
            onChange={(e) =>
              setForm({
                ...form,
                email: e.target.value
              })
            }
            required
          />

          <textarea
            placeholder="Address"
            className="w-full p-2 border rounded"
            value={form.address}
            onChange={(e) =>
              setForm({
                ...form,
                address: e.target.value
              })
            }
            required
          />

          <select
            className="w-full p-2 border rounded"
            value={form.service_type}
            onChange={(e) =>
              setForm({
                ...form,
                service_type: e.target.value
              })
            }
          >
            <option value="HOME_SERVICE">
              Home Service
            </option>

            <option value="STORE_WALKIN">
              Store Walk-in
            </option>
          </select>

          <select
            className="w-full p-2 border rounded"
            value={form.technician_id}
            onChange={(e) =>
              setForm({
                ...form,
                technician_id: e.target.value
              })
            }
            required
          >

            <option value="">
              Assign Technician
            </option>

            {Array.isArray(technicians) &&
              technicians.map((t) => (

                <option
                  key={t.id}
                  value={t.id}
                >
                  {t.user_id}
                </option>

              ))}

          </select>

          <button
            className="bg-indigo-600 text-white px-4 py-2 rounded"
          >
            Create Request
          </button>

        </form>

      </div>

    </Layout>
  );
}